import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type ModelDto = ClientInferResponseBody<typeof contract.models.findMine>;

export const fetchModel = async (): Promise<ModelDto | null> => {
  const response = await api.models.findMine.query();

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
